import React from 'react';
import { IconSvgProps } from '@models/common';

const ExpertLogo: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_9502_5826)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.7378 12L7.58752 10.8903L5.05646 5.82765C4.87996 5.47411 4.95007 5.0469 5.23094 4.76908C5.51184 4.49127 5.93956 4.42474 6.29104 4.60536L19.1243 11.1865C19.4292 11.343 19.6216 11.6572 19.6216 12C19.6216 12.3428 19.4293 12.6569 19.1243 12.8135L6.29104 19.3946C5.93956 19.5752 5.51184 19.5087 5.23094 19.2309C4.95007 18.9531 4.87996 18.5259 5.05647 18.1723L7.59978 13.0852L13.7378 12Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_9502_5826'>
          <rect
            width='24'
            height='24'
            fill='currentColor'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ExpertLogo;
